"use client";
import { Icon } from "@components/blocks/icon/Icon";
import { FacilityClusterPoint } from "@lib/utils/types/FacilityClusterPoint";
import { MARKER_OBJECT } from "@repo/map-helpers";
import { ROUNDED_ICONS_IDS } from "@repo/map-helpers/src/markers";
import { FacilitySummaryResponse } from "@repo/shared-types";
import { Marker } from "react-map-gl";

import type { useClusters } from "../hooks";
import { IMarkerPopup } from "../markerPopup/MarkerPopup";

interface IClusters {
  clusters: ReturnType<typeof useClusters>[0];
  onClusterClickEventHandler: (clusterPoint: FacilityClusterPoint) => void;
  onMarkerClick: (marker: Omit<IMarkerPopup, "onClose">) => void;
}

export function Clusters({
  clusters,
  onClusterClickEventHandler,
  onMarkerClick,
}: IClusters) {
  return (
    <>
      {clusters.map(cluster => {
        const [longitude, latitude] = cluster.geometry.coordinates;
        const categoryId = cluster?.properties
          ?.categoryId as keyof typeof MARKER_OBJECT; // TYPE MAPING DUE TO THE PROPERTIES BEING ANY
        const iconName = MARKER_OBJECT[categoryId] ?? "markerFallback";
        if (!cluster.properties?.cluster) {
          return (
            <Marker
              key={`cluster-${cluster.properties.id}`}
              latitude={latitude}
              longitude={longitude}
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                onMarkerClick({
                  id: cluster.properties.id,
                  latitude,
                  longitude,
                  categoryId,
                  facility: cluster.properties as FacilitySummaryResponse,
                });
              }}
            >
              <div
                className={`overflow-hidden shadow-3xl ${
                  ROUNDED_ICONS_IDS.indexOf(cluster?.properties?.categoryId) >
                  -1
                    ? "rounded-full"
                    : "rounded-[10px]"
                }`}
              >
                <Icon iconName={iconName} />
              </div>
            </Marker>
          );
        }
        return (
          <Marker
            key={`cluster-${cluster.id}`}
            latitude={latitude}
            longitude={longitude}
            onClick={() =>
              onClusterClickEventHandler({
                id: String(cluster.id),
                latitude,
                longitude,
              })
            }
          >
            <div className="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full border-4 border-white bg-accent p-2 text-lg font-bold text-primary-foreground">
              {cluster.properties.point_count > 99
                ? "+99"
                : cluster.properties.point_count}
            </div>
          </Marker>
        );
      })}
    </>
  );
}
